import { __assign, __awaiter, __generator, __read, __spread, __values } from "tslib";
import fs from 'fs';
import path from 'path';
import { spawn } from 'child_process';
import prettier from 'prettier';
import appRoot from 'app-root-path';
var defaults = {
    lastSync: 0,
    hasAddedReact: false
};
var stateFilePath = path.join(appRoot.path, 'config/state.json');
var readmeFilePath = path.join(appRoot.path, 'README.md');
var codeRegex = /<!-- ?Dependencies ?-->([\s\S]*?)(?:<!--)/i;
var scriptsRegex = / src="([^"]*)"/g;
export var addScriptDependency = function () {
    var e_1, _a;
    var _b;
    var scripts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        scripts[_i] = arguments[_i];
    }
    try {
        for (var scripts_1 = __values(scripts), scripts_1_1 = scripts_1.next(); !scripts_1_1.done; scripts_1_1 = scripts_1.next()) {
            var script = scripts_1_1.value;
            var readme = fs.readFileSync(readmeFilePath, 'utf8');
            var readmeMatch = readme.match(codeRegex);
            if (readmeMatch === null) {
                if (readme.includes('create-typescript-react-library')) {
                    console.error("Cannot fix readme - the setup script needs to be run first");
                    process.exit(69);
                }
                return;
            }
            else {
                var index = readmeMatch.index;
                var prevScriptsHTML = readmeMatch[1];
                var prevScripts = __spread(((_b = prevScriptsHTML.match(scriptsRegex)) !== null && _b !== void 0 ? _b : [])).map(function (tag) { return tag.slice(6, -1); });
                if (prevScripts.indexOf(script) === -1) {
                    var trimmedHTML = prevScriptsHTML.trim();
                    fs.writeFileSync(readmeFilePath, readme.slice(0, index) + "<!-- Dependencies -->" + (trimmedHTML ? "\n" + trimmedHTML : '') + "\n<script src=\"" + script + "\"></script>\n\n<!--" + readme.slice(index + readmeMatch[0].length));
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (scripts_1_1 && !scripts_1_1.done && (_a = scripts_1.return)) _a.call(scripts_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
export var installDependencies = function (deps, type) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(deps.length > 0)) return [3, 2];
                return [4, new Promise(function (resolve, reject) {
                        var subprocess = spawn('yarn', __spread(['add'], deps, (type ? ["--" + type] : [])), {
                            stdio: 'inherit'
                        });
                        subprocess.on('close', function (code) {
                            if (code === 0) {
                                resolve();
                            }
                            else {
                                reject(new Error("Error code " + code));
                            }
                        });
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2];
        }
    });
}); };
var packageJSONPath = path.join(appRoot.path, 'package.json');
export var formatJSON = function (obj) {
    var _a;
    var json = JSON.parse(fs.readFileSync(packageJSONPath, 'utf8'));
    return prettier.format(JSON.stringify(obj), __assign(__assign({}, ((_a = json === null || json === void 0 ? void 0 : json.prettier) !== null && _a !== void 0 ? _a : {})), { parser: 'json-stringify' }));
};
export var mutatePackageJSON = function (diffs) {
    store(packageJSONPath, diffs);
};
export var getState = function () { return store(stateFilePath, undefined, defaults); };
export var setState = function (diffs) {
    store(stateFilePath, diffs, defaults);
};
export var store = function (filePath, diffs, defaults) {
    var e_2, _a;
    var json = (defaults !== null && defaults !== void 0 ? defaults : {});
    try {
        json = __assign(__assign({}, defaults), JSON.parse(fs.readFileSync(filePath, 'utf8')));
    }
    catch (_b) {
        fs.writeFileSync(filePath, formatJSON(json));
    }
    if (diffs && Object.keys(diffs).length > 0) {
        try {
            for (var _c = __values(Object.entries(diffs)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2), k = _e[0], v = _e[1];
                json[k] = typeof v === 'function' ? v(json[k]) : v;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        fs.writeFileSync(filePath, formatJSON(json));
    }
    return json;
};
//# sourceMappingURL=index.js.map